<script lang="ts">
	import './layout.css';
	import { beforeNavigate, afterNavigate } from '$app/navigation';
	import { page } from '$app/state';
	import { env } from '$env/dynamic/public';
	import { Toaster } from '$lib/components/ui/sonner/index.js';

	import favicon from '$lib/assets/favicon.ico';
	import favicon16 from '$lib/assets/favicon-16x16.png';
	import favicon32 from '$lib/assets/favicon-32x32.png';
	import favicon192 from '$lib/assets/android-192x192.png';
	import favicon512 from '$lib/assets/android-512x512.png';
	import appleTouchIcon from '$lib/assets/apple-touch-icon.png';
	import Navbar from '$lib/components/navigation/navbar.svelte';
	import { ModeWatcher } from 'mode-watcher';
	import ProgressBar from '$lib/components/ProgressBar.svelte';
	import { tick } from 'svelte';
	import FooterSection from '$lib/components/sections/footer-section.svelte';
	import ScrollToTop from '$lib/components/ui/scroll-to-top.svelte';
	import FacebookPixel from '$lib/components/FacebookPixel.svelte';
	import AuditFloatingButton from '$lib/components/sections/audit-floating-button.svelte';
	import ExitIntentPopup from '$lib/components/ExitIntentPopup.svelte';

	let { children } = $props();
	let showLoader = $state(false);
	let timer: ReturnType<typeof setTimeout> | null = null;

	function clearLoader() {
		if (timer) {
			clearTimeout(timer);
			timer = null;
		}
		showLoader = false;
	}

	beforeNavigate((navigation) => {
		if (navigation.type === 'popstate') return;

		clearLoader();

		timer = setTimeout(() => {
			showLoader = true;
		}, 200);
	});

	afterNavigate(async (navigation) => {
		clearLoader();

		await tick();

		window.gtag?.('config', env.PUBLIC_GA_ID, {
			page_path: navigation.to?.url.pathname || page.url.pathname,
			page_title: document.title
		});
	});
</script>

<svelte:head>
	<meta http-equiv="x-ua-compatible" content="ie=edge" />
	<meta name="author" content="Juslin Komenan" />

	<link rel="icon" type="image/png" sizes="512x512" href={favicon512} />
	<link rel="icon" type="image/png" sizes="192x192" href={favicon192} />
	<link rel="icon" type="image/png" sizes="32x32" href={favicon32} />
	<link rel="icon" type="image/png" sizes="16x16" href={favicon16} />
	<link rel="apple-touch-icon" href={appleTouchIcon} />
	<link rel="icon" href={favicon} />

	<link rel="preconnect" href="https://www.googletagmanager.com" />
	<link rel="dns-prefetch" href="//connect.facebook.net" />

	<link rel="alternate" hreflang="x-default" href={page.url.href} />
	<link rel="alternate" type="application/rss+xml" title="Juslin RSS" href="/rss.xml" />
</svelte:head>

<ModeWatcher />

<Toaster richColors position="top-center" closeButton />
{#if showLoader}
	<ProgressBar ariaLabel="Chargement de la page en cours" />
{/if}
<main class="min-h-[100svh] min-h-screen pt-16">
	<Navbar />
	{@render children()}
	<FooterSection />
	<AuditFloatingButton />
	<ScrollToTop />
	<ExitIntentPopup />
</main>
<FacebookPixel pixelId="2120786765419208" />
